"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * /IPO辅导备案信息-企业详情
 */
var web_1 = __importDefault(require("../../../config/web"));
var fieldtools_1 = __importDefault(require("../../../src/modules/commonutil/fieldtools"));
var table_jbxx = $("#table_jbxx");
var table_jgxx = $("#table_jgxx");
var table_cwzb = $("#table_cwzb");
var table_zygd = $("#table_zygd");
loadcontent();
function loadcontent() {
    //基本信息
    $(".TUTOR_OBJECT", table_jbxx).html(info.TUTOR_OBJECT); //辅导对象	TUTOR_OBJECT
    $(".TUTOR_ORG", table_jbxx).html(info.TUTOR_ORG); //辅导机构	TUTOR_ORG
    $(".TUTOR_PROCESS_STATE", table_jbxx).html(info.TUTOR_PROCESS_STATE); //辅导状态	TUTOR_PROCESS_STATE
    $(".DISPATCH_ORG", table_jbxx).html(info.DISPATCH_ORG); //派出机构	DISPATCH_ORG     
    $(".RECORD_DATE", table_jbxx).html(fieldtools_1["default"].dateformat(info.RECORD_DATE)); //备案时间	RECORD_DATE
    $(".REPORT_TYPE", table_jbxx).html(info.REPORT_TYPE); //报告类型	REPORT_TYPE
    //机构信息
    getdata({
        reportName: "RPT_HSF9_BASIC_ORGINFO",
        columns: "REG_ADDRESS,FOUND_DATE,LEGAL_PERSON,CHAIRMAN,ORG_PROFILE,BUSINESS_SCOPE"
    }).then(function (json) {
        if (json && json.result && json.result.data.length > 0) {
            table_jgxx.show();
            var data = json.result.data[0];
            $(".REG_ADDRESS", table_jgxx).html(data.REG_ADDRESS); //注册地	REG_ADDRESS
            $(".FOUND_DATE", table_jgxx).html(fieldtools_1["default"].dateformat(data.FOUND_DATE)); //成立日期	FOUND_DATE
            $(".LEGAL_PERSON", table_jgxx).html(data.LEGAL_PERSON); // 法人代表	LEGAL_PERSON
            $(".CHAIRMAN", table_jgxx).html(data.CHAIRMAN); // 董事长	CHAIRMAN
            $(".ORG_PROFILE", table_jgxx).html(data.ORG_PROFILE); //公司简介	ORG_PROFILE
            $(".BUSINESS_SCOPE", table_jgxx).html(data.BUSINESS_SCOPE); //经营范围	BUSINESS_SCOPE
        }
    });
    //财务数据
    getdata({
        reportName: "RPT_FNINDICATOR_DECLARE",
        columns: "REPORT_DATE,TOTAL_ASSETS_ADJUST,TOTAL_EQUITY_ADJUST,TOTAL_EQUITY_ADJUST,MINORITY_EQUITY_ADJUST,TOTAL_OPERATE_INCOME,PARENT_NETPROFIT,CAPITAL_RESERVE_ADJUST,UNASSIGN_RPOFIT_ADJUST,PARENT_BVPS_ADJUST,BASIC_EPS_ADJUST,DILUTED_EPS_ADJUST,PER_NETCASHOPERATE_ADJUST,ROE_WEIGHT_FN,REPORT_TYPE",
        sortColumns: "REPORT_DATE",
        sortTypes: -1,
        pageSize: 4,
        filter: "(SECURITY_CODE=\"" + info.SECURITY_CODE + "\")(REPORT_TYPE=\"\u5E74\u5EA6\u62A5\u544A\")(REPORT_DATE<='" + fieldtools_1["default"].dateformat(info.UPDATE_DATE) + "')"
    }).then(function (json) {
        if (json && json.result && json.result.data && json.result.data.length > 0) {
            $("#cwsj").show();
            for (var i = 0; i < 4; i++) {
                if (json.result.data[i])
                    loadcell(i + 1, json.result.data[i]);
                else
                    delcell(i + 1);
            }
        }
    });
    //主要股东
    getdata({
        reportName: "RPT_HOLDERSDECLARE",
        columns: "HOLD_NUM,HOLD_RATIO,HOLDER_NAME,NUM_SUM,RATIO_SUM,RN,END_DATE",
        sortColumns: "RN",
        sortTypes: -1
    }).then(function (json) {
        if (json && json.result && json.result.data && json.result.data.length > 0) {
            $("#zygd").show();
            var list = json.result.data;
            var count = list.length;
            for (var i = 0; i < count; i++) {
                var item = list[i];
                var tds = $("tr", table_zygd).eq(item.RN);
                $("td", tds).eq(0).html(item.RN);
                $("td", tds).eq(1).html('<div class="ellipsis" style="width: 550px;">' + item.HOLDER_NAME + '</div>').attr("title", item.HOLDER_NAME);
                $("td", tds).eq(2).html(item.HOLD_NUM);
                $("td", tds).eq(3).html(item.HOLD_RATIO);
            }
            $("td", $("tr", table_zygd).eq(11)).eq(1).html(list[0].NUM_SUM);
            $("td", $("tr", table_zygd).eq(11)).eq(2).html(list[0].RATIO_SUM);
            for (var i_1 = count; i_1 < 10; i_1++) {
                $("tr", table_zygd).eq(count + 1).remove();
            }
            $("#date_zygd").html("截止日期:" + fieldtools_1["default"].dateformat(list[0].END_DATE, 'YYYY-MM-DD 周W'));
        }
    });
}
function getdata(opt) {
    return $.ajax({
        url: web_1["default"].getWebPath('datacenter') + 'api/data/v1/get',
        type: "GET",
        dataType: "jsonp",
        data: $.extend({}, {
            filter: "(ORG_CODE=\"" + info.ORG_CODE + "\")",
            columns: 'ALL',
            source: "WEB",
            client: "WEB"
        }, opt)
    });
}
function loadcell(index, data) {
    $(".REPORT_DATE td", table_cwzb).eq(index + 1).html(fieldtools_1["default"].dateformat(data.REPORT_DATE)); //报表日期	REPORT_DATE
    $(".TOTAL_ASSETS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_ASSETS_ADJUST, { omit: false, zoom: -8, num: 4 })); //总资产	TOTAL_ASSETS_ADJUST
    $(".TOTAL_EQUITY_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_EQUITY_ADJUST, { omit: false, zoom: -8, num: 4 })); //净资产	TOTAL_EQUITY_ADJUST
    $(".MINORITY_EQUITY_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.MINORITY_EQUITY_ADJUST, { omit: false, zoom: -4, num: 2 })); //少数股东权益	MINORITY_EQUITY_ADJUST
    $(".TOTAL_OPERATE_INCOME td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.TOTAL_OPERATE_INCOME, { omit: false, zoom: -8, num: 4 })); //营业总收入	TOTAL_OPERATE_INCOME
    $(".PARENT_NETPROFIT td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PARENT_NETPROFIT, { omit: false, zoom: -8, num: 4 })); //净利润	PARENT_NETPROFIT
    $(".CAPITAL_RESERVE_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.CAPITAL_RESERVE_ADJUST, { omit: false, zoom: -4, num: 2 })); //资本公积	CAPITAL_RESERVE_ADJUST
    $(".UNASSIGN_RPOFIT_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.UNASSIGN_RPOFIT_ADJUST, { omit: false, zoom: -8, num: 4 })); //未分配利润	UNASSIGN_RPOFIT_ADJUST
    $(".PARENT_BVPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PARENT_BVPS_ADJUST)); //每股净资产	PARENT_BVPS_ADJUST
    $(".BASIC_EPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.BASIC_EPS_ADJUST)); //基本每股收益	BASIC_EPS_ADJUST
    $(".DILUTED_EPS_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.DILUTED_EPS_ADJUST)); //稀释每股收益	DILUTED_EPS_ADJUST
    $(".PER_NETCASHOPERATE_ADJUST td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.PER_NETCASHOPERATE_ADJUST)); //每股现金流	PER_NETCASHOPERATE_ADJUST
    $(".ROE_WEIGHT_FN td", table_cwzb).eq(index).html(fieldtools_1["default"].fieldfmt(data.ROE_WEIGHT_FN)); //净资产收益率	ROE_WEIGHT_FN
}
function delcell(index) {
    $(".REPORT_DATE td", table_cwzb).eq(index + 1).remove();
    $("tr:not(.REPORT_DATE)", table_cwzb).find("td:eq(" + index + ")").remove();
}
